/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum LabExamsListAliases {
  AUTOC_EXAM_GROUPS = 'autoc-exam-groups',
  AUTOC_EXAM_PRESENTATION = 'autoc-exam-presentation',
  AUTOC_EXAM_TYPE = 'autoc-exam-type',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATE_PICKER_FINAL_DATE = 'date-picker-final-date',
  DATE_PICKER_INITIAL_DATE = 'date-picker-initial-date',
  DECK_LAB_EXAMS = 'deck-lab-exams',
  EXAM_CARD = 'exam-card',
  FETCH_EXAM_GROUPS = 'fetch-exam-groups',
  FETCH_EXAM_TYPE = 'fetch-exam-type',
  FETCH_EXAMS = 'fetch-exams',
  FIELD_EXAM_GROUPS = 'field-exam-groups',
  FIELD_EXAM_TYPE = 'field-exam-type',
  FIELD_TYPE_PRESENTATION = 'field-type-presentation',
  FILTER_EXAM = 'filter-exam',
  FILTER_FIELD_FINAL_DATE = 'filter-field-final-date',
  FILTER_FIELD_INITIAL_DATE = 'filter-field-initial-date',
  FILTERED_LIST_EXAM = 'filtered-list-exam',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  LAYOUT_LAB_EXAMS_LIST = 'layout-lab-exams-list',
  LEGENDS_LIST_EXAM = 'legends-list-exam',
  MAPPER_EXAM_GROUPS = 'mapper-exam-groups',
  MAPPER_EXAM_PRESENTATION = 'mapper-exam-presentation',
  MAPPER_EXAM_TYPE = 'mapper-exam-type',
  MEDIA_CONTAINER_EXAMS_LIST = 'media-container-exams-list',
  MODAL_EXAMS = 'modal-exams',
  PANEL_0 = 'panel-0',
  PANEL_MODAL_EXAMS = 'panel-modal-exams',
  PDF_VIEWER_EXAM_DETAILS = 'pdf-viewer-exam-details',
  TEXT_EXAM_GROUPS = 'text-exam-groups',
  TEXT_EXAM_PRESENTATION = 'text-exam-presentation',
  TEXT_EXAM_TYPE = 'text-exam-type',
}
export { LabExamsListAliases };
